const LAST_SEEN_KEY = "meteotracker.patchNotes.lastSeen"

export function loadLastSeen() {
  try {
    return localStorage.getItem(LAST_SEEN_KEY)
  } catch {
    return null
  }
}

export function saveLastSeen(version) {
  try {
    localStorage.setItem(LAST_SEEN_KEY, version)
  } catch {
    // Private Mode / gesperrter Storage: Dialog erscheint dann bei jedem Login
  }
}

// Neue Nutzer (Willkommen noch nicht gesehen) bekommen keine Patch Notes, nur die Version wird gemerkt.
export function autoOpenDecision({ notes, currentVersion, lastSeen, welcomeSeen }) {
  if (lastSeen === currentVersion) return "skip"
  if (!welcomeSeen) return "markSeen"
  return notes.some((n) => n.version === currentVersion) ? "open" : "skip"
}
